import { useUserStore } from "@/store/modules/user";
import { defineStore } from "pinia";

export default defineStore("main", {
  actions: {
    async initFetch() {
      const userStore = useUserStore();
      await userStore.initializeCurrentUser();
    },
  },
});
